'use client'

import styles from './ProductTitle.module.scss'

interface ProductTitleProps {
	productName: string
}

export const ProductTitle = ({ productName }: ProductTitleProps) => {
	return <p className={styles.productTitle}>{productName}</p>
}
